<template>
<div class="container">
	<b-modal :model-value="modalModContractual" :no-close-on-backdrop="true" hide-header hide-footer centered>
		<div class="text-center">
   <h3><b><i>{{ labels.title }}</i></b></h3> </div> 
		<div>
			<b-row>
				<b-col cols="1"></b-col>
				<b-col cols="5" class="text-left">
     <h5>{{labels.fechaProceso}}</h5> 
				</b-col>
				<b-col cols="6" class="text-left">
					<input type="date" :items="fechaProceso" class="form-control">
				</b-col>
			</b-row>
   <b-row v-if="fgl_procesar==1 && listContratos.length==0"> 
				<b-col cols="12" class="text-center">
     <h3><i>{{ labels.noRow }}</i></h3> 
				</b-col>
			</b-row>
			<div class="row col-md-12 justify-content-center " v-if="listContratos != 0">
				<b-table md-card md-fixed-header :items="listContratos">
					<b-table-row slot="b-table-row" slot-scope="{ item }">
     <b-table-cell :md-label="labels.nroContrato" class="border">{{ item?.nro_contrato }}</b-table-cell> 
     <b-table-cell :md-label="labels.fechaInicial" class="border text-left">{{ item?.fecha_inicial }}</b-table-cell> 
     <b-table-cell :md-label="labels.canonAnterior" class="border text-right">{{ Intl?.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(item?.canon_anterior) }}</b-table-cell> 
     <b-table-cell :md-label="labels.canonActual" class="border text-right">{{ Intl?.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(item?.canon_actual) }}</b-table-cell> 
     <b-table-cell :md-label="labels.cuotas" class="border">{{ item?.cuotas }}</b-table-cell> 
					</b-table-row>
				</b-table>
			</div>
			<div class="mt-3">
    <b-button v-if="fgl_procesar==0" class="md-primary" @click="procesar()">{{ labels.procesar }}</b-button> 
    <b-button v-if="fgl_procesar==0 || listContratos?.length>0" class="md-accent" @click="cierraModal">{{ labels.close }}</b-button> 
			</div>
		</div>
	</b-modal>
</div>
</template>

<script>

import ContratoCuota from '../../services/ContratoCuota' 

export default {
name : 'ModificacionContractual',
props : ['modalModContractual'],
data : () => ({
        fechaProceso : '',
	fgl_procesar : 0,
	listContratos: [],
    }),
computed : {
labels(){
 if (this.$store.state._language == "es-ES"){ 
		return {
			title : 'Modificacion Automatica de Canones',
			procesar : 'Procesar',
			close : 'Cerrar',
			fechaProceso : 'Fecha proceso',
   noRow: 'Procesando información....', 
			nroContrato: 'Contrato',
			fechaInicial : 'Fecha Inicial',
			canonAnterior: 'Canon Anterior',
			canonActual: 'Canon Actual',
			cuotas : 'Cuotas',
		}
	}else{
		return {
			title : 'Contractual change',
			procesar : 'Process',
			close : 'Close',
			fechaProceso : 'Process date'
		}
	}
}
},
methods : {
	cierraModal(){
  this.fechaProceso = '' 
  this.listContratos=[] 
  this.fgl_procesar = 0 
  this.$emit('cierraModal',false) 
	},
	procesar(){
  this.fgl_procesar=1 
  const v_fecha_proceso = this.f_calcula_fecha_proceso() 
  if (this.fechaProceso != v_fecha_proceso) { 
   this.fechaProceso = v_fecha_proceso 
   this.fgl_procesar = 0 
		} else {
   this.listContratos=[] 
   ContratoCuota.modificacionContractual( 
    this.fechaProceso,this.$store.state.userId) 
   .then((res) => { 
    this.listContratos = res.data.listContratos 
    this.$toast.success(res.data.message) 
			})
   .catch((err) => { 
    console.log(err) 
			})
		}
	},
	f_calcula_fecha_proceso() {
  let v_fecha = new Date(this.fechaProceso+"T00:00:00") 
  let mes = v_fecha.getMonth() 
  while (mes == v_fecha.getMonth()) { 
   v_fecha.setDate(v_fecha.getDate()+1) 
		}
  v_fecha.setDate(v_fecha.getDate()-1) 
  const caño = v_fecha.getFullYear() 
  const cmes = String(v_fecha.getMonth() + 1).padStart(2, '0') 
  const cdia = String(v_fecha.getDate()).padStart(2, '0') 
		const vc_fecha = `${caño}-${cmes}-${cdia}` 
		return vc_fecha
	},
},
}
</script>

<style lang="css">
  .b-table-cell-container { 
    padding: 15px !important;
  }
  .b-table-head-label { 
    padding-left: 30px !important;
  }
</style>

